// extracted by mini-css-extract-plugin
module.exports = {"header":"LinkTableHeader_header__373l7","text":"LinkTableHeader_text__1Am2v","menu":"LinkTableHeader_menu__1t8sz","mappingName":"LinkTableHeader_mappingName__3L9RJ"};